import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            w: '100%',
            backgroundColor: 'background.accent.default',
        },
        main: {
            m: {base: 0, xl: '0 auto'},
            maxW: remCalc(1400),
            direction: {base: 'column-reverse', md: 'row'},
            py: {base: 'large.base', md: 'small.md'},
            gap: {base: 'small.base', md: 'small.md'},
            alignItems: {xl: 'center'},
        },
        imagebox: {
            flexGrow: 0,
            flexShrink: 0,
            flexBasis: {base: '100%', md: remCalc(229), lg: remCalc(226), xl: remCalc(213)},
        },
        image: {
            borderRadius: 'large-1',
        },
        textblock: {
            flexDirection: 'column',
            textAlign: {base: 'center', md: 'left'},
            gap: {base: 'xsmall.base', lg: 'xsmall.lg', xl: 'small.lg'},
            alignItems: {base: 'center', md: 'flex-start'},
        },
        heading: {
            textStyle: 'head-large',
            fontWeight: 'medium',
            color: 'foreground.neutral.inverse',
        },
        bodycopy: {
            textStyle: 'body-medium',
            fontWeight: 'normal',
            color: 'foreground.neutral.inverse',
        },
        cta: {
            textDecoration: 'none !important',
            w: {base: remCalc(227), md: remCalc(310), lg: remCalc(213)},
            variant: 'outline',
        },
    },
}
